import styled from 'styled-components';

import { brandFont } from 'styles/brand-font';

export const InformationTitle = styled.h2`
  margin-inline-start: 1rem;
  font: ${brandFont.headerThree};
  color: ${({ theme }) => theme.token('text-default')};

  ${Styles.desktopLarge} {
    margin-block-start: 1rem;
    margin-block-end: 1.125rem;
  }
`;

export const NutritionInformationWrapper = styled.div`
  ${Styles.desktopLarge} {
    margin: 0 -1rem;
  }
`;
